module.exports = __webpack_public_path__ + "img/meitene-darbiba.0a58205f.png";